import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/registro_marca/registroMarca';
import RegistroMarca from './RegistroMarca';


const ms2p = (state) => {
  return {
    ...state.registro_marca_rm,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(RegistroMarca);
